import AdminConfigApiResponseDto from "../../types/dtos/admin/AdminConfigApiResponseDto";
import { DefaultSettingDto } from "../../types/dtos/admin/DefaultSettingDto";
import { OverrideDto } from "../../types/dtos/admin/OverrideDto";
import SentJourneyApiResponseDto from "../../types/dtos/admin/SentJourneyApiResponseDto";
import SentJourneyRecipientApiResponseDto from "../../types/dtos/admin/SentJourneyRecipientApiResponseDto";
import { WindowDto } from "../../types/dtos/admin/WindowDto";
import { apiClient } from "../apiClient";
import UserJourneysTabApiResponseDto from "../../types/dtos/admin/UserJourneysTabApiResponseDto";
import PaginationSearchAndFilterCriteria from "../../types/admin/client-journeys/PaginationSearchAndFilterCriteria";
import UserDetailPageLoadApiResponseDto from "../../types/dtos/admin/UserDetailPageLoadApiResponseDto";
import UserDetailJourneyApiResponseDto from "../../types/dtos/admin/UserDetailJourneyApiResponseDto";
import UserDetailHistoryPageApiResponseDto from "../../types/dtos/admin/UserDetailHistoryPageApiResponseDto";
import AdminJourneyOverviewApiResponseDto from "../../types/dtos/admin/AdminJourneyOverviewApiResponseDto";
import { JourneySettingsDto } from "../../types/admin/journey-overview/JourneySettingsDto";
import AdminJourneySettingsApiResponseDto from "../../types/dtos/admin/AdminJourneySettingsApiResponseDto";
import AdminJourneyUpdateSettingsApiResponseDto from "../../types/dtos/admin/AdminJourneyUpdateSettingsApiResponseDto";
import ForceCloseJourneyResponseDto from "../../types/dtos/admin/ForceCloseJourneyResponseDto";
import JourneyCreationInitialLoadApiResponseDto from "../../types/dtos/admin/JourneyCreationInitialLoadApiResponseDto";
import TitleValidationResponse from "../../types/client-journeys/TitleValidationResponse";
import SubmitJourneyCreationDto from "../../types/dtos/admin/submission/SubmitJourneyCreationDto";
import { SendJourneyDetails } from "../../types/admin/client-journeys/SendJourneyDetails";
import RecipientTabType from "../../types/admin/client-journeys/RecipientTabType";
import RecipientUserApiResponseDto from "../../types/dtos/admin/client-journeys/RecipientUserApiResponseDto";
import SendJourneyDto from "../../types/dtos/admin/submission/SendJourneyDto";
import { AdminActionOriginType } from "../../types/admin/AdminActionOriginType";
import { AddNewEmployeeFormData } from "../../types/dtos/admin/employees/AddNewEmployeeFormData";
import AddEmployeeFormOptionData from "../../types/dtos/admin/employees/AddEmployeeFormOptionData";

class adminApi {
  constructor(authToken: string | undefined) {
    this.accessToken = authToken;
  }

  accessToken: string | undefined;

  getUsersForSearch(
    criteria: PaginationSearchAndFilterCriteria,
    isNonAdminUserWithManagerConfigAccess: boolean,
    onSuccess: (data: UserJourneysTabApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/get-users-for-search?isNonAdminUserWithManagerConfigAccess=" +
      isNonAdminUserWithManagerConfigAccess;

    return apiClient(this.accessToken, apiUrl, {
      body: JSON.stringify(criteria),
    }).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** POST xlsx blob of the current Users-page filtered set (unpaged). */
  exportUsersSpreadsheet(
    criteria: PaginationSearchAndFilterCriteria,
    isNonAdminUserWithManagerConfigAccess: boolean
  ): Promise<Blob> {
    const apiUrl =
      "dashboards/admin/export-users-spreadsheet?isNonAdminUserWithManagerConfigAccess=" +
      isNonAdminUserWithManagerConfigAccess;
    return apiClient(
      this.accessToken,
      apiUrl,
      {
        method: "POST",
        body: JSON.stringify(criteria),
      },
      "BLOB"
    ) as Promise<Blob>;
  }

  getUserPageInfo(
    userId: number,
    isNonAdminUserWithManagerConfigAccess: boolean,
    pageSize: number,
    pageNumber: number,
    onSuccess: (data: UserDetailPageLoadApiResponseDto) => void,
    onError: (error: any) => void,
    searchTerm?: string | null
  ) {
    let apiUrl =
      "dashboards/admin/get-user-page-info?userId=" +
      userId +
      "&isNonAdminUserWithManagerConfigAccess=" +
      isNonAdminUserWithManagerConfigAccess +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber;
    if (searchTerm) {
      apiUrl += "&searchTerm=" + searchTerm;
    }
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  getUserAdminHistoryPage(
    userId: number,
    isNonAdminUserWithManagerConfigAccess: boolean,
    pageSize: number,
    pageNumber: number,
    onSuccess: (data: UserDetailHistoryPageApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/get-user-admin-history-page?userId=" +
      userId +
      "&isNonAdminUserWithManagerConfigAccess=" +
      isNonAdminUserWithManagerConfigAccess +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  isAllowedToViewThisUser(
    userId: number,
    isNonAdminUserWithManagerConfigAccess: boolean,
    onSuccess: (data: boolean) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/is-allowed-to-view-this-user?userId=" +
      userId +
      "&isNonAdminUserWithManagerConfigAccess=" +
      isNonAdminUserWithManagerConfigAccess;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  paginateHistoricalJourneys(
    userId: number,
    pageSize: number,
    pageNumber: number,
    onSuccess: (data: UserDetailJourneyApiResponseDto) => void,
    onError: (error: any) => void,
    searchTerm?: string | null
  ) {
    let apiUrl =
      "dashboards/admin/paginate-historical-journeys?userId=" +
      userId +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber;
    if (searchTerm) {
      apiUrl += "&searchTerm=" + searchTerm;
    }
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateManagerForUserId(
    userId: number,
    proposedManagerId: number,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-manager-for-user-id?userId=" +
      userId +
      "&proposedManagerId=" +
      proposedManagerId +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateJourneyManagerForUserId(
    userId: number,
    proposedJourneyManagerId: number | null,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-journey-manager-for-user-id?userId=" +
      userId +
      "&proposedJourneyManagerId=" +
      proposedJourneyManagerId +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateStatusForUserId(
    userId: number,
    proposedStatusId: number,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-status-for-user-id?userId=" +
      userId +
      "&proposedStatusId=" +
      proposedStatusId +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateAppraisalLevelForUserId(
    userId: number,
    proposedAppraisalLevelId: number,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-appraisal-level-for-user-id?userId=" +
      userId +
      "&proposedAppraisalLevelId=" +
      proposedAppraisalLevelId +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateJobTitleForUserId(
    userId: number,
    proposedJobTitleId: number,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-job-title-for-user-id?userId=" +
      userId +
      "&proposedJobTitleId=" +
      proposedJobTitleId +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateLocationForUserId(
    userId: number,
    proposedLocationId: number,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-location-for-user-id?userId=" +
      userId +
      "&proposedLocationId=" +
      proposedLocationId +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  searchCustomFieldValues(
    fieldNumber: number,
    query: string,
    limit = 50
  ): Promise<string[]> {
    const q = encodeURIComponent(query ?? "");
    return apiClient(
      this.accessToken,
      `dashboards/admin/search-custom-field-values?fieldNumber=${fieldNumber}&q=${q}&limit=${limit}`
    ) as Promise<string[]>;
  }

  updateCustomFieldForUserId(
    userId: number,
    fieldNumber: number,
    proposedFieldValue: string,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ) {
    let apiUrl =
      "dashboards/admin/update-custom-field-for-user-id?userId=" +
      userId +
      "&fieldNumber=" +
      fieldNumber +
      "&proposedFieldValue=" +
      encodeURIComponent(proposedFieldValue) +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  sendReminder(
    journeyReference: string,
    sendToBoth: boolean,
    originString: AdminActionOriginType,
    onSuccess: (data: any) => void,
    onError: (error: any) => void,
    userId?: number,
    managerRoleId?: number
  ) {
    let apiUrl =
      "dashboards/admin/send-reminder?journeyReference=" +
      journeyReference +
      "&sendToBoth=" +
      sendToBoth +
      "&originString=" +
      originString;
    if (userId) {
      apiUrl += "&userId=" + userId;
    }
    if (managerRoleId) {
      apiUrl += "&managerRoleId=" + managerRoleId;
    }
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  cancelJourney(
    userId: number,
    journeyReference: string,
    isDualPrepJourney: boolean,
    originString: AdminActionOriginType,
    onSuccess: () => void,
    onError: () => void,
    id?: number | null
  ) {
    let apiUrl =
      "dashboards/admin/cancel-journey?userId=" +
      userId +
      "&journeyReference=" +
      journeyReference +
      "&isDualPrepJourney=" +
      isDualPrepJourney +
      "&originString=" +
      originString;
    if (id) {
      apiUrl += "&id=" + id;
    }
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess();
      },
      (error) => {
        onError();
      }
    );
  }

  reopenJourney(
    userId: number,
    journeyReference: string,
    answerSetId: number,
    isDualPrepJourney: boolean,
    originString: AdminActionOriginType,
    onSuccess: () => void,
    onError: () => void,
    dualPrepAnswerSetId?: number | null
  ) {
    let apiUrl =
      "dashboards/admin/reopen-journey?userId=" +
      userId +
      "&journeyReference=" +
      journeyReference +
      "&answerSetId=" +
      answerSetId +
      "&isDualPrepJourney=" +
      isDualPrepJourney +
      "&originString=" +
      originString;
    if (dualPrepAnswerSetId) {
      apiUrl += "&dualPrepAnswerSetId=" + dualPrepAnswerSetId;
    }
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess();
      },
      (error) => {
        onError();
      }
    );
  }

  sendJourney(
    userId: number,
    journeyReference: string,
    originString: AdminActionOriginType,
    onSuccess: () => void,
    onError: () => void
  ) {
    let apiUrl =
      "dashboards/admin/send-journey?userId=" +
      userId +
      "&journeyReference=" +
      journeyReference +
      "&originString=" +
      originString;
    return apiClient(this.accessToken, apiUrl).then(
      (data) => {
        onSuccess();
      },
      (error) => {
        onError();
      }
    );
  }

  /** Loads the configuration for the client form and its overrides */
  getClientFormConfigById(
    clientFormId: number,
    onSuccess: (clientForms: AdminConfigApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-client-form-config-by-id?clientFormId=" +
        clientFormId
    ).then(
      (data) => {
        const configData = data as AdminConfigApiResponseDto;
        onSuccess(configData);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Sends the Default Settings Dto to the server to be saved */
  saveDefaultSettings(
    clientFormId: number,
    defaultSettings: DefaultSettingDto,
    onSuccess: (data: WindowDto[]) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/save-default-settings?clientFormId=" + clientFormId,
      {
        body: JSON.stringify(defaultSettings),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Sends the Override Dto to the server to be saved/updated */
  saveOverride(
    clientFormId: number,
    overrideDto: OverrideDto,
    onSuccess: (data: OverrideDto[]) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/save-override?clientFormId=" + clientFormId,
      {
        body: JSON.stringify(overrideDto),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Send the Override Dto to the server to be deleted */
  deleteOverride(
    clientFormId: number,
    overrideDto: OverrideDto,
    onSuccess: (data: OverrideDto[]) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/delete-override?clientFormId=" + clientFormId,
      {
        body: JSON.stringify(overrideDto),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Gets the dtos of sent journeys to show on page */
  getSendingHistory(
    onSuccess: (data: SentJourneyApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-sending-history"
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Gets the dtos for recipients of a given sent journey id */
  getClientSentJourneyRecipients(
    clientSentJourneyId: number,
    onSuccess: (data: SentJourneyRecipientApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-recipients-for-client-sent-journey?clientSentJourneyId=" +
        clientSentJourneyId
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Loads the journey overviews for the client of the logged in user */
  GetJourneyOverviews(
    onSuccess: (journeyOverviews: AdminJourneyOverviewApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-journey-overviews"
    ).then(
      (data) => {
        const journeyOverviews = data as AdminJourneyOverviewApiResponseDto;
        onSuccess(journeyOverviews);
      },
      (error) => {
        onError(error);
      }
    );
  }

  getJourneySettings(
    journeyId: number,
    onSuccess: (data: JourneySettingsDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-journey-settings?journeyId=" + journeyId
    ).then(
      (data) => {
        const outcome = data as AdminJourneySettingsApiResponseDto;
        onSuccess(outcome.settings);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateJourneySettings(
    settings: JourneySettingsDto,
    onSuccess: (data: AdminJourneyUpdateSettingsApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/update-journey-settings",
      {
        body: JSON.stringify(settings),
      }
    ).then(
      (data) => {
        const outcome = data as AdminJourneyUpdateSettingsApiResponseDto;
        onSuccess(outcome);
      },
      (error) => {
        onError(error);
      }
    );
  }

  forceCloseJourney(
    journeyId: number,
    titleConfirmation: string,
    reason: string,
    onSuccess: (data: ForceCloseJourneyResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(this.accessToken, "dashboards/admin/force-close-journey", {
      method: "POST",
      body: JSON.stringify({
        journeyId,
        titleConfirmation,
        reason,
      }),
    }).then(
      (data) => {
        onSuccess(data as ForceCloseJourneyResponseDto);
      },
      (error) => {
        onError(error);
      }
    );
  }

  getJourneyCreationPageData(
    onSuccess: (data: JourneyCreationInitialLoadApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-journey-creation-page-data"
    ).then(
      (data) => {
        const outcome = data as JourneyCreationInitialLoadApiResponseDto;
        onSuccess(outcome);
      },
      (error) => {
        onError(error);
      }
    );
  }

  validateJourneyTitle(
    title: string,
    onSuccess: (data: TitleValidationResponse) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/validate-journey-title?title=" + title
    ).then(
      (data) => {
        const response = data as TitleValidationResponse;
        onSuccess(response);
      },
      (error) => {
        onError(error);
      }
    );
  }

  createJourney(
    clientJourney: SubmitJourneyCreationDto,
    onSuccess: (journeyId: string) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/create-client-journey",
      {
        body: JSON.stringify(clientJourney),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  getJourneyDetailsForSendReview(
    clientJourneyId: string,
    onSuccess: (data: SendJourneyDetails) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-journey-details-for-send-review?clientJourneyId=" +
        clientJourneyId
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Retrieve the user count for the send now confirmation modal */
  getRecipientCountForSendClientJourneyConfirmation(
    recipientTabType: RecipientTabType,
    userIdsSwitchValue: boolean,
    excludeInductions: boolean,
    ids: string[],
    onSuccess: (data: number) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-recipient-count-for-send-client-journey-confirmation?recipientTabType=" +
        recipientTabType +
        "&userIdsSwitchValue=" +
        userIdsSwitchValue +
        "&excludeInductions=" +
        excludeInductions,
      {
        body: JSON.stringify(ids),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Retrieve the user count for the send client journey confirmation modal */
  getRecipientsForSendClientJourneyConfirmation(
    recipientTabType: RecipientTabType,
    excludeInductions: boolean,
    ids: string[],
    onSuccess: (data: RecipientUserApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-recipients-for-send-client-journey-confirmation?recipientTabType=" +
        recipientTabType +
        "&excludeInductions=" +
        excludeInductions,
      {
        body: JSON.stringify(ids),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Sends the client journey to the selected recipients */
  sendClientJourney(
    dto: SendJourneyDto,
    journeyId: string,
    onSuccess: (data: boolean) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/send-client-journey?clientJourneyId=" + journeyId,
      {
        body: JSON.stringify(dto),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Get initial data needed for adding a new employee */
  getAddEmployeeFormOptions(
    onSuccess: (data: AddEmployeeFormOptionData) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/get-add-employee-form-options"
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /** Check if email address is already in use */
  isEmailAddressAvailable(
    emailAddress: string,
    onSuccess: (isAvailable: boolean) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/admin/is-email-address-available?emailAddress=" +
        encodeURIComponent(emailAddress)
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  startImpersonation(targetUserId: number) {
    return apiClient(this.accessToken, "dashboards/admin/start-impersonation", {
      body: JSON.stringify({ targetUserId }),
    });
  }

  endImpersonation() {
    return apiClient(this.accessToken, "dashboards/admin/end-impersonation", {
      method: "POST",
    });
  }

  /** Submit new employee data */
  addNewEmployee(
    employeeData: AddNewEmployeeFormData,
    onSuccess: (newUserId: number) => void,
    onError: (error: any) => void
  ) {
    return apiClient(this.accessToken, "dashboards/admin/create-new-employee", {
      body: JSON.stringify(employeeData),
    }).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }
}

export default adminApi;
